import '../../../../static-source/helpers/gettext/shim';
import Vue from 'vue';
import Vuex from 'vuex';

import GettextMixin from '@globalSource/helpers/gettext/mixin';

import CellphoneRecovery from '@cellPhoneRecovery/components/cellphone_recovery';
import cellphoneRecoveryStore, {
    // eslint-disable-next-line no-unused-vars
    MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS,
    CELLPHONE_RECOVERY_STORE_NAMESPACE,
    MUTATION_UPDATE_COUNTRY_SELECT_OPTIONS,
} from '@cellPhoneRecovery/store';

import FlashcallVerificationCellphoneRecoveryForm from '@globalSource/components/flashcall_verification_cellphone_recovery_form';
import TwoFactorTimer from '@globalSource/components/twofactor_timer/index';
import inputMaxLengthDirective from '@globalSource/directives/inputMaxLength';
import inputSetFocusDirective from '@globalSource/directives/inputSetFocus';
// eslint-disable-next-line max-len
import SmsVerificationCellphoneRecoveryForm from '@globalSource/components/sms_verification_cellphone_recovery_form/index.js';

Vue.use(Vuex);
Vue.directive('maxlength', inputMaxLengthDirective);
Vue.directive('focus', inputSetFocusDirective);

Vue.mixin(GettextMixin);

Vue.component('sms-verification-cellphone-recovery-form', SmsVerificationCellphoneRecoveryForm);
Vue.component('flashcall-verification-cellphone-recovery-form', FlashcallVerificationCellphoneRecoveryForm);
Vue.component('two-factor-timer', TwoFactorTimer);

const store = new Vuex.Store({
    modules: {
        [CELLPHONE_RECOVERY_STORE_NAMESPACE]: cellphoneRecoveryStore,
        settings: {
            namespaced: true,
            state: {
                staticUrl: '/id/static/',
            },
        },
    },
});

const waitForBackendData = () => new Promise((resolve) => {
    if (window.cellphoneRecoveryData) {
        resolve(window.cellphoneRecoveryData);
    } else {
        setTimeout(() => waitForBackendData().then(resolve), 100);
    }
});

const initApp = async () => {
    try {
        const { cellphoneSettings, countryCallingCodesOptions } = await waitForBackendData();

        const settingsToUpdate = {
            MinLength: parseInt(cellphoneSettings.cellphoneMinLength, 10),
            MaxLength: parseInt(cellphoneSettings.cellphoneMaxLength, 10),
            riddlerFeature: cellphoneSettings.riddlerFeature || '',
            riddlerDefaultType: cellphoneSettings.riddlerDefaultType || '',
            urls: cellphoneSettings.urls || {},
            codeLifetime: cellphoneSettings.codeLifetime || '',
            smsMaxAttempts: cellphoneSettings.smsMaxAttempts || '',
            codeLength: cellphoneSettings.codeLength || '',
            countryCodeByIp: (cellphoneSettings.countryCodeByIp && cellphoneSettings.countryCodeByIp.CountryCode) || '',
            dailyLimit: cellphoneSettings.smsMaxAttempts || 0,
            intervalMs: cellphoneSettings.smsDelayAttempts ? Math.floor(cellphoneSettings
                .smsDelayAttempts / 60) : 0,
            requestMaxFrequency: 1,
        };

        store.commit(`${CELLPHONE_RECOVERY_STORE_NAMESPACE}/${MUTATION_UPDATE_CELLPHONE_RECOVERY_SETTINGS}`, settingsToUpdate);
        store.commit(`${CELLPHONE_RECOVERY_STORE_NAMESPACE}/${MUTATION_UPDATE_COUNTRY_SELECT_OPTIONS}`, countryCallingCodesOptions);

        const App = new Vue({
            store,
            components: {
                CellphoneRecovery,
            },
        });

        window.App = App;
        window.App.store = store;

        App.$mount('.vv-app');
    } catch (error) {
        console.error('Error initializing app:', error);
    }
};

initApp();
